import { EvaButtonComponent } from './eva-button.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OptionalLinkModule } from '../optional-link/optional-link.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [
        EvaButtonComponent
    ],
    imports: [ 
        CommonModule,
        OptionalLinkModule,
        TranslateModule
    ],
    exports: [
        EvaButtonComponent
    ],
    providers: [],
})
export class EvaButtonModule {}